import * as z from 'zod/v4';

import { drawNumberSchema } from '../draw/entry.js';
import { customerIdSchema } from '../lib/entry.js';

const marketplaceWagerDetailsSharesSchema = z.object({
  customerId: customerIdSchema,
  memberName: z.string(),
  numberOfShares: z.number(),
  role: z.number(),
  status: z.number(),
  isCurrentUser: z.boolean(),
});

export const marketplaceWagerDetailsResponse = z.object({
  containerWithDraw: z.object({
    groupName: z.string(),
    currentUserStatusInGroup: z.number(),
    activatedDrawDescription: z.string(),
    shares: z.array(marketplaceWagerDetailsSharesSchema),
    bettor: z.string(),
    commissionPercent: z.number(),
    groupType: z.number(),
    activatedDrawId: z.number().brand<'ActivatedDrawId'>(),
    activatedDrawStatus: z.number(),
    drawNumber: drawNumberSchema,
    regClose: z.string().transform((str) => new Date(str)),
    wagerSerial: z.string(),
    memberMaxShares: z.number(),
    maxShares: z.number(),
    shareCommittedPrice: z.string(),
    totalBalance: z.string(),
    wagerAmount: z.string(),
    wagerSharePrice: z.string(),
    isSubmittable: z.boolean(),
    isAllowedToSubmit: z.boolean(),
    currentUserNumberOfShares: z.number(),
    soldShares: z.number(),
    buyinCloseTime: z.string().transform((str) => new Date(str)),
    activatedDrawName: z.string().nullable(),
    subProductId: z.number(),
    preliminaryRowExists: z.boolean(),
    description: z.string().nullable(),
    numShares: z.number(),
    sharePrice: z.string(),
    containerId: z.number(),
    editorId: z.number(),
    groupId: z.number(),
    productId: z.number(),
    name: z.string(),
  }),
});
